module.exports = __webpack_public_path__ + "media/images/photos/23-26d3a398bc8975f561a03446128d9851.jpg";